<template>
  <div>
    <h1>Find the Invisible Cow</h1>

    <p>Move your cursor around to find the cow. It’s hiding behind the shouting.</p>

    <div class="audio-warning">
      <div class="audio-warning__icon" v-html="image.speaker"></div>
      <p class="auto-warning__text">Make sure you turn your audio on before playing.</p>
    </div>

    <div class="loading-bar" v-if="!audioPlayer.loaded">
      <div class="loading-bar-inner" :style="`width:${audioPlayer.loadedAmount * 100}%;`">
      </div>
    </div>

    <div class="start-button" v-if="audioPlayer.loaded">
      <find-button @click="setPage(PAGE_GAME)">
        Start Game
      </find-button>
    </div>

    <p class="note">
      If you do not hear anything, it’s possible that your browser does not support the Web Audio
      API. Currently supported browsers are
      <a href="http://google.com/chrome" target="_blank">Chrome 10+</a>,
      <a href="http://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox 25+</a>,
      <a href="http://www.opera.com/" target="_blank">Opera 15+</a>, and
      <a href="http://www.apple.com/au/safari/" target="_blank">Safari 6+</a>.
    </p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { PAGE_GAME } from 'constants';
import audioPlayer from 'lib/audioPlayer';
import Button from 'components/Button.vue';
import speaker from 'assets/image/speaker.svg';

export default {
  components: {
    'find-button': Button,
  },
  data: () => ({
    PAGE_GAME,
    image: {
      speaker,
    },
    audioPlayer,
  }),
  methods: mapActions([
    'setPage',
  ]),
};
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 0;
}

.audio-warning {
  align-items: center;
  display: flex;
  font-style: italic;
  padding-left: 0;

  &__icon {
    display: inline-block;
    margin-right: 1em;
    width: 3em;
    height: 3em;
  }

  &__text {
      margin: 0;
  }
}

.loading-bar,
.start-button {
  margin-top: 1rem;
}

.loading-bar {
  border: 1px solid #38678f;

  .loading-bar-inner {
    background-color: #4682b4;
    height: 50px;
  }
}

.note {
  font-size: .875em;
  margin: 2em 0 0;
}
</style>

<style lang="scss">
  .audio-warning__icon svg {
    fill: #bbb;
  }
</style>



// WEBPACK FOOTER //
// Welcome.vue?7acd454c